export default __webpack_public_path__ + "static/media/addIcon.6f64f83c.svg";